import React, { Component } from 'react';
import Article from './ui/Article.js'
import Section from './ui/Section.js'
import Code from './ui/Code.js'
import ReactMarkdown from 'react-markdown';

class Enum extends Component {
    render() {
        const overview = this.props.descriptor.overview || this.props.descriptor.description;
        return (
            <Article kind="Enum" title={this.props.descriptor.name} subtitle={this.props.descriptor.summary}>
                {overview &&
                    <Section title="Overview">
                        <ReactMarkdown source={overview} />
                    </Section>
                }
                <Section title="Fully Qualified Name">
                    <Code>{this.props.descriptor.fullName}</Code>
                </Section>
                <Section title="Values">
                    <table class="table">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Number</th>
                                <th scope="col">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.props.descriptor.values.map((value) => (
                                <tr>
                                    <td>{value.name}</td>
                                    <td>{value.number}</td>
                                    <td>{value.description}</td>
                                </tr>
                            )) }
                        </tbody>
                    </table>
                </Section>
            </Article>
        );
    }
}

export default Enum;



// WEBPACK FOOTER //
// ./src/reference/Enum.js